import { render, staticRenderFns } from "./library-items.vue?vue&type=template&id=1645958f&scoped=true"
import script from "./library-items.vue?vue&type=script&lang=js"
export * from "./library-items.vue?vue&type=script&lang=js"
import style0 from "./library-items.vue?vue&type=style&index=0&id=1645958f&prod&lang=css"
import style1 from "./library-items.vue?vue&type=style&index=1&id=1645958f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1645958f",
  null
  
)

export default component.exports